import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const PointGrantAllCompany = lazy(() =>
  import(/* webpackChunkName: "PointGrantAllCompany" */ '../../components/rewards/PointGrantAllCompany')
);

export default function PointGrantAllCompanyComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <PointGrantAllCompany {...props} />
    </Suspense>
  );
}
